/** @format */

import React from "react";
import SpeedDial from "./SpeedDial";

const Layout = () => {
  return (
    <div className='header'>

      <SpeedDial />
    </div>
  );
};

export default Layout;
